export default {"src":"/_next/static/media/logo-white.4701d848.svg","height":40,"width":183};